import { Language } from './language';

const es = {
    code: Language.es,

	// HOME PAGE

	t_description: 'Niña baterista, {age} años de edad',
	t_close: 'Cerrar',

	b_home: 'Inicio',
	b_about: 'Acerca de mi',
	b_press: 'Prensa y Medios',
	b_shows: 'Presentaciones en vivo',
	b_latest_show: 'Reciente',
	b_soultone: 'Soultone',
	b_paiste: 'Paiste',
	b_collision: 'Collision',
	b_language: 'Español',
	b_share: 'Compartir',
	b_scroll_to_top: 'Ir al inicio',
	b_click: 'Click',
	b_tap: 'Presionar',

	t_english: 'Inglés',
	t_spanish: 'Español',
	t_portuguese: 'Portugués',
	t_italian: 'Italiano',
	t_french: 'Francés',
	t_german: 'Alemán',
	t_chinese: 'Chino',

	// SHOWS PAGE

	KRKComeTogether2026DROM_title: 'Festival KRFK Come Together',
	KRKComeTogether2026DROM_description: 'DROM, Nueva York City',

	KRKComeTogether2026Chelsea_title: 'Festival KRFK Come Together',
	KRKComeTogether2026Chelsea_description: 'Chelsea Table & Stage, Nueva York City',

	RockFantasy2026Whisky_title: 'Campamento de Fantasía del Rock and Roll',
	RockFantasy2026Whisky_description: 'The Whisky a Go Go, Hollywood CA.',

	RockFantasy2026Viper_title: 'Campamento de Fantasía del Rock and Roll',
	RockFantasy2026Viper_description: 'The Viper Room, Hollywood CA.',

	FulcrumCelebrationOfLight2026_title: 'Celebración de la Luz de Fulcrum',
	FulcrumCelebrationOfLight2026_description: 'Sheraton Grand Seattle',

	QueenTribute_title: 'Tributo a Queen',
	QueenTribute_description: 'School of Rock Seattle',

	FremontFridays2025_title: 'Viernes en Fremont 2025',
	FremontFridays2025_description: 'Viernes en Fremont Seattle',

	DrumFantasyCamp2025_title: 'Campamento Drum Fantasy 2025',
	DrumFantasyCamp2025_description: 'Campamento Drum Fantasy en Los Ángeles',

	ClassicMetal_title: 'Metal Clásico',
	ClassicMetal_description: 'School of Rock Seattle',

	StAlsGrandDay2024_title: 'Presentación del dia de los abuelos 2024',
	StAlsGrandDay2024_description: 'Escuela de San Alfonso en Seattle',

	BlackViolinConcert_title: 'Concierto Black Violin con The World Your Orchestra',
	BlackViolinConcert_description: 'Teatro The Paramount',

	MexicanIndependenceDay2024_title: 'Celebracion de la Independencia de Mexico con La Orquesta Civica de Ballard',
	MexicanIndependenceDay2024_description: 'Ayuntamiento de Seattle',

	BluesRock_title: 'Blues Rock',
	BluesRock_description: 'School of Rock Seattle',

	BallardSeaFoodFest2024_title: 'Festival de comida del mar en Ballard 2024',
	BallardSeaFoodFest2024_description: 'Festival de comida del mar en Ballard',

	Funk_title: 'Funk',
	Funk_description: 'School of Rock Seattle',

	Heart_title: 'Heart',
	Heart_description: 'School of Rock Seattle',

	ModernMetal_title: 'Metal Moderno',
	ModernMetal_description: 'School of Rock Seattle',

	SeasonPreviewWinter2023_title: 'Concierto de avance de invierno 2023',
	SeasonPreviewWinter2023_description: 'School of Rock Seattle',

	SmashingPumpkins_title: 'Smashing Pumpkins',
	SmashingPumpkins_description: 'School of Rock Seattle',

	Nirvana_title: 'Nirvana',
	Nirvana_description: 'School of Rock Seattle',

	HairMetal_title: 'Hair Metal',
	HairMetal_description: 'School of Rock Seattle',

	Deftones_title: 'Deftones',
	Deftones_description: 'School of Rock Seattle',

	TalentShow2023_title: 'Show de Talentos 2023',
	TalentShow2023_description: 'Seattle Salmon Bay K-8',

	SeasonPreviewSpring2023_title: 'Concierto de avance de primavera 2023',
	SeasonPreviewSpring2023_description: 'School of Rock Seattle',

	Ramones_title: 'Los Ramones',
	Ramones_description: 'School of Rock Seattle',

	Soundtrack_title: 'Show de Soundtracks',
	Soundtrack_description: 'School of Rock Seattle',

	PopPunkVsEmo_title: 'Pop Punk Vs. Emo',
	PopPunkVsEmo_description: 'School of Rock Seattle',

	_90sNostalgia_title: 'Nostalgia de los 90\'s',
	_90sNostalgia_description: 'School of Rock Seattle',

	TalentShow2022_title: 'Show de Talentos 2022',
	TalentShow2022_description: 'Seattle Salmon Bay K-8',

	// PRESS PAGE

	b_watch_here: 'Ver aquí',

	king_5_feature_title: 'Reportaje de Fulcrum / King 5',
	king_5_feature_description: 'Reportaje de Seattle King 5 TV patrocinado por Fulcrum',

	bateristland_title: 'Bateristland Featuring',
	bateristland_description: 'Entrevista en el canal de YouTube Bateristland',

	komo_news_title: 'Reportaje de Komo News',
	komo_news_description: 'Entrevista en Seattle Refined',

	andrew_rooney_drums_title: 'Reacción de Andrew Rooney',
	andrew_rooney_drums_description: 'Andrew Rooney reacciona a la interpretación de Victoria de Tom Sawyer de Rush',

	upper_lefters_interview_title: 'Entrevista de Upper Lefters',
	upper_lefters_interview_description: 'Entrevista en el canal de YouTube Upper Lefters sobre la carrera de Victoria y sus planes a futuro',

	the_eagle_969_title: '96.9 The Eagle Estación de Radio de Éxitos Clásicos',
	the_eagle_969_description: 'Publicación del blog de 96.9 The Eagle Classic Hits sobre el cover de Rush de Victoria',

	fox_13_news_title: 'Reportaje de Fox 13 Seattle News',
	fox_13_news_description: 'Reportaje en la sección "True Northwest"',

	the_daly_migs_show_interview_title: 'Entrevista con The Daly Migs Show',
	the_daly_migs_show_interview_description: 'Entrevista acerca de ser invitada a subir al escenario con Godsmack',

	alizee_defan_07_02_2024_title: 'Entrevista con "Alizee Defan"',
	alizee_defan_07_02_2024_description: 'Entrevista exclusiva',

	jaime_mendez_news_06_26_2024_title: 'Entrevista con "Jaime Mendez News"',
	jaime_mendez_news_06_26_2024_description: 'Noticiero local de Seattle en español',

	bien_informado_03_22_2023_title: 'Artículo de "Bien Informado"',
	bien_informado_03_22_2023_description: 'Artículo de Sitio de Noticias Argentino acerca de Victoria',

	wave_potter_reaction_01_30_2023_title: 'Reacción de Wave Potter',
	wave_potter_reaction_01_30_2023_description: 'Wave Potter reacciona al cover de Victoria Lux Æterna de Metallica',
	
	// ABOUT PAGE

	b_back: 'Regresar',

	t_title: 'Victoria Acosta',
	t_pronouns: '(ella)',

	b_read_more: 'Leer mas',
	b_read_less: 'Leer menos',
	b_stat_age: 'Edad',
	b_stat_shows: 'Conciertos',
	b_stat_yrs: 'Años Tocando',
	b_stat_awards: 'Premios',

	t_about: `
Con baquetas en mano y ritmo en el alma, Victoria Acosta, de {age} años, es una de las jóvenes bateristas más emocionantes del momento. Nació en El Paso, Texas, creció en Guadalajara, México, y ahora vive en Seattle, donde es reconocida por su dedicación, energía y presencia escénica.

Victoria comenzó a tocar batería a los cuatro años y recibió su primera batería el 13 de septiembre de 2018. Se formó en Musicalerías Academy en Guadalajara y continuó sus estudios en Seattle. Después de una clase de prueba en School of Rock el 29 de mayo de 2022, saltó el programa Rock 101 y entró al Performers Program. Desde entonces, se ha presentado en {shows} shows en vivo.

Ha grabado cientos de videos para redes sociales y, el 13 de junio de 2024, fue invitada por el compositor italiano Alberto Rigonni como baterista invitada en Nemesis Call. Recibió un endoso de Soultone Cymbals el 12 de septiembre de 2024 y se unió al roster de artistas de Collision Drumsticks el 8 de marzo de 2025.

En agosto de 2025, Victoria asistió al Drum Fantasy Camp en Los Ángeles, donde estudió con Dave Weckl, Dennis Chambers, Peter Erskine y Gavin Harrison. Ese mes también comenzó a estudiar con el educador Dave Stark, cuya guía continúa impulsando su técnica, musicalidad y voz artística.

El 13 de febrero de 2026 se convirtió oficialmente en artista de Paiste. Ese mes también participó en el Rock and Roll Fantasy Camp, tocó junto a Nita Strauss, Stewart Copeland, Monte Pittman, Steve Stevens, Skunk Baxter y Leland Sklar, y se presentó en The Viper Room y Whisky a Go Go. En 2026 ganó la Beca Neil Peart Drum Set, otorgada por la Percussive Arts Society y Hudson.

Además de la batería, Victoria comenzó a estudiar violín en cuarto grado y se unió a la World Youth Orchestra en 2024. Compartió escenario con Black Violin en el Paramount Theatre y debutó como percusionista con la Ballard Civic Orchestra en el Town Hall Seattle durante una celebración de la Independencia de México.

Sus reconocimientos incluyen el Gold Prize y el Fantastic Technique Award del London Young Musician Contest 2022, además del Annual Star Musician Award y el Outstanding Drummer Special Award en 2023. Victoria practica a diario, superando sus límites con determinación y creatividad.
	`,

	// PRESS PAGE

	t_footer: 'Todos los derechos reservados',

		// SOULTONE: 

		b_visit_artist_page: 'Visita mi página de artista'

};

export default es;